import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import Icon from '@material-ui/core/Icon';
import ListItem from '@material-ui/core/ListItem';
import Collapse from '@material-ui/core/Collapse';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import UIActionCreators from 'modules/resale/store/reducers/ui/actionCreators';
import shouldHidden from '../shouldHidden';
import ListMenu from '../../ListMenu';
import disabledMenu from '../disabledMenu';
import fontDefault from '../fontDefault';
// import RenderIcons from '../RenderIcons';

const SecondLevel = props => {
  const {
    hasChildren,
    item,
    id,
    to,
    isDisabled,
    level,
    isSelectedAndOpen,
    handleClick,
    isClicked,
    classes,
    externalLink,
  } = props;
  const isHidden = shouldHidden(item.hidden || {});
  if (!hasChildren) {
    return (
      <>
        {!isHidden.desktop && (
          <SecondLevelWithoutChildren
            hasChildren={hasChildren}
            item={item}
            id={id}
            to={to}
            isDisabled={isDisabled}
            level={level}
            isSelectedAndOpen={isSelectedAndOpen}
            handleClick={handleClick}
            isClicked={isClicked}
            classes={classes}
            externalLink={externalLink}
            {...props}
          />
        )}
      </>
    );
  }
  return (
    <>
      {!isHidden.desktop && (
        <SecondLevelWithChildren
          hasChildren={hasChildren}
          item={item}
          id={id}
          to={to}
          isDisabled={isDisabled}
          level={level}
          isSelectedAndOpen={isSelectedAndOpen}
          handleClick={handleClick}
          isClicked={isClicked}
          classes={classes}
          {...props}
        />
      )}
    </>
  );
};

const SecondLevelWithoutChildren = ({
  item,
  to,
  isDisabled,
  handleClick,
  selectedIndex,
  classes,
  externalLink,
}) => {
  const dispatch = useDispatch();
  const {
    dealerStore: { currentDealer },
    userStore: { userSite },
  } = useSelector(state => ({
    dealerStore: state.dealerStore,
    userStore: state.userStore,
  }));
  const isSelected = selectedIndex === item.link;
  const selectedItemClass = isSelected
    ? { root: classes.selectedItemSubMenu }
    : { root: classes.noSelectedItem };

  const fandiIntegration =
    currentDealer &&
    currentDealer?.externalDealerIdentification?.find(
      externalDealer => externalDealer.externalProvider === 'FANDI'
    );

  //regra adicionada para integração fandi; melhorar essa logica futuramente.
  if (externalLink && !fandiIntegration) {
    return null;
  }

  const openFinancingMonitorLink = externalLink => {
    if (!userSite?.cpf) {
      dispatch(
        UIActionCreators.snackbarManagement(
          'error',
          'Usuário não tem CPF cadastrado.'
        )
      );
      return;
    }

    const externalUrl = externalLink(
      fandiIntegration?.externalIdentification?.split('|')?.[0],
      currentDealer?.cnpj,
      userSite?.cpf
    );

    window.open(externalUrl, '_blank');
  };

  return (
    <div
      data-test={item.name}
      key={item.id}
      className={isSelected ? classes.rootSubItem : undefined}
    >
      {externalLink ? (
        <ListItem
          selected={isSelected}
          classes={{
            selected: classes.subItem,
            root: classes.root,
          }}
          disabled={isDisabled}
          onClick={() => openFinancingMonitorLink(externalLink)}
        >
          <>
            <ListItemText>
              <Typography
                noWrap
                classes={selectedItemClass}
                style={{
                  ...fontDefault,
                  fontSize: '12px',
                  fontWeight: '100',
                  marginLeft: 50,
                }}
              >
                {item.label}
              </Typography>
            </ListItemText>
          </>
        </ListItem>
      ) : (
        <Link
          classes={{ root: classes.rootSubItem }}
          to={!isDisabled ? to : undefined}
          style={disabledMenu(isDisabled)}
          onClick={() => handleClick(item.link, isDisabled, false)}
        >
          <ListItem
            selected={isSelected}
            classes={{
              selected: classes.subItem,
              root: classes.root,
            }}
            disabled={isDisabled}
          >
            {/* <ListItemIcon classes={selectedItemClass}>
            <Icon>
              <RenderIcons icon={item.icon} />
            </Icon>
          </ListItemIcon> */}
            <ListItemText classes={selectedItemClass}>
              <Typography
                noWrap
                classes={selectedItemClass}
                style={{
                  ...fontDefault,
                  fontSize: '12px',
                  fontWeight: '100',
                  marginLeft: 50,
                }}
              >
                {item.label}
              </Typography>
            </ListItemText>
          </ListItem>
        </Link>
      )}
    </div>
  );
};
const SecondLevelWithChildren = ({
  item,
  id,
  to,
  isDisabled,
  level,
  isSelectedAndOpen,
  handleClick,
  isClicked,
  isSelectedAndOpenFunction,
  classes,
  isMobile,
  handleDrawerClose,
  open,
  location,
  selectedIndex,
  ...props
}) => {
  const isSelected = selectedIndex === item.link;

  const selectedItemClass = isSelected
    ? { root: classes.selectedItemSubMenu }
    : { root: classes.noSelectedItem };

  return (
    <div
      key={item.id}
      data-test={item.name}
      className={isSelected ? classes.rootSubItem : undefined}
    >
      <Link
        classes={{ root: classes.rootSubItem }}
        to={!isDisabled ? to : undefined}
        style={disabledMenu(isDisabled)}
        onClick={() => handleClick(item.link, isDisabled, true)}
      >
        <ListItem
          selected={isSelected}
          classes={{
            selected: classes.subItem,
            root: classes.root,
          }}
          disabled={isDisabled}
        >
          {/* <ListItemIcon classes={{ root: classes.subItemIcon }}>
            <Icon>
              <RenderIcons icon={item.icon} />
            </Icon>
          </ListItemIcon> */}
          <ListItemText classes={selectedItemClass}>
            <Typography
              noWrap
              classes={selectedItemClass}
              style={{
                ...fontDefault,
                fontSize: '12px',
                fontWeight: '100',
                marginLeft: 50,
              }}
            >
              {item.label}
            </Typography>
          </ListItemText>
          {isSelected ? (
            <KeyboardArrowUp
              style={{ width: 'auto' }}
              classes={{ root: classes.selectedItem }}
            />
          ) : (
            <KeyboardArrowDown
              style={{ width: 'auto' }}
              classes={{ root: classes.root }}
            />
          )}
        </ListItem>
      </Link>
      <Collapse in={isSelected && open} timeout="auto" unmountOnExit>
        <ListMenu
          {...props}
          menuTree={item.children}
          level={level + 1}
          classes={classes}
          disabled={isDisabled}
          isMobile={isMobile}
          handleDrawerClose={handleDrawerClose}
        />
      </Collapse>
    </div>
  );
};

export default SecondLevel;
